import Machines from './Machines'

export default Machines
